<template>
    <div>
        <ht-sidebar-dialog
                title="分配角色用户"
                :visible="dialogVisible"
                width="1040px"
                :before-close="handleClose"
                close-on-click-modal
                append-to-body
        >

            <el-collapse>
                <el-header>
                    <el-row>
                        <el-col :span="6">
                            <el-button size="small" @click="showUserDialog()" icon="el-icon-plus">加入用户</el-button>
                            <eip-popconfirm-button
                                    type="danger"
                                    title="确定删除吗？"
                                    icon="el-icon-delete"
                                    @onConfirm="remove"
                                    style="margin-left:3px;"
                            >{{ $t("common.delete") }}</eip-popconfirm-button
                            >
                        </el-col>
                        <el-col :span="18">
                            <el-input
                                    size="small"
                                    style="width:380px"
                                    clearable
                                    placeholder="通过姓名,账号来搜索"
                                    prefix-icon="el-icon-search"
                                    v-model="userSearch"
                            ></el-input>
                            <el-button
                                    style="margin-left: 20px"
                                    size="small"
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="search(true)"
                            >{{ $t("common.search") }}</el-button
                            >
                            <el-button size="small" icon="el-icon-refresh" @click="reset">{{
                                $t("common.reset")
                                }}</el-button>
                        </el-col>
                    </el-row>
                </el-header>
                <el-main class="approval-item__content">
                    <el-table
                            :data="rows"
                            border
                            style="width: 100%;"
                            size="medium"
                            v-loading.fullscreen.lock="fullscreenLoading"
                            @selection-change="handleChecked"
                    >
                        <el-table-column  type="selection"    width="40" ></el-table-column>
                        <el-table-column type="index" width="50" align="center" label="序号" />
                        <el-table-column  prop="fullname" label="用户名称"  width="300"  />
                        <el-table-column prop="account" label="账号"  />
                        <el-table-column prop="email" label="邮箱" />
                        <el-table-column prop="mobile" label="手机号码" />
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button 
                                    @click="swap(scope.$index, 'down') || btnLoading"
                                    :disabled="scope.$index == rows.length - 1"
                                    >
                                    <i class="el-icon-arrow-down"></i>
                                </el-button>
                                <el-button 
                                    :disabled="scope.$index == 0 || btnLoading"  
                                    @click="swap(scope.$index, 'up')"
                                    >
                                    <i class="el-icon-arrow-up"></i>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
                <el-footer height="45px">
                    <el-pagination
                            class="pagination"
                            :disabled="fullscreenLoading"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pagination.page"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="pagination.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="pagination.total">
                    </el-pagination>
                </el-footer>
            </el-collapse>
        </ht-sidebar-dialog>
        <eip-user-dialog ref="eipUserDialog" @onConfirm="userDialogOnConfirm" append-to-body />
    </div>
</template>

<script>
    import EipUserDialog from "@/components/dialog/EipUserDialog.vue";
    import EipPopconfirmButton from "@/components/eipControl/EipPopconfirmButton";
    import req from "@/request.js";
    export default {
        name: "UserGroupManager",
        components: {EipUserDialog,EipPopconfirmButton},
        data(){
            return {
                dialogVisible:false,
                fullscreenLoading:false,
                groupId:"",
                rows:[],
                checkBoxData:[],
                pagination: {
                    pageBean: {
                        page: 1,
                        pageSize: 10,
                        total: 0
                    }
                },
                userSearch:"",
                btnLoading:false
            }
        },
        methods:{
            handleChecked(value){
                this.checkBoxData = value;
            },
            reset(){
                this.userSearch="";
                this.search(true);
            },
            search(resetPage){
                if (resetPage) {
                    this.pagination = { page: 1, pageSize: 20, total: 0 };
                }
                let pageBean = { pageBean: this.pagination };
                let querys = [];
                if(this.userSearch){
                    querys.push({
                        property: "fullname",
                        value: this.userSearch,
                        group: "main",
                        operation: "LIKE",
                        relation: "OR"
                    });
                    querys.push({
                        property: "account",
                        value: this.userSearch,
                        group: "main",
                        operation: "LIKE",
                        relation: "OR"
                    });
                }
                pageBean.querys = querys;
                this.fullscreenLoading=true;
                req.post("${uc}/uc/ucGroupUser/v1/getGroupUsers?groupId="+this.groupId,pageBean)
                    .then(rep =>{
                        let {data} = rep;
                        this.rows= data.rows;
                        this.pagination.page = data.page;
                        this.pagination.pageSize = data.pageSize;
                        this.pagination.total = data.total;

                    }).finally(() => (this.fullscreenLoading = false));
            },
            remove(){
                var ids = [];
                if (this.checkBoxData && this.checkBoxData.length > 0) {
                    for (let index = 0; index < this.checkBoxData.length; index++) {
                        ids.push(this.checkBoxData[index].groupUserId);
                    }
                }
                if (ids.length > 0) {
                    req.remove("${uc}/uc/ucGroupUser/v1/remove?ids="+ids).then(res=>{
                        if (res.data.state){
                            this.$message({
                                message: "刪除用户成功",
                                type: "success",
                                showClose: true
                            });
                            this.search();
                        }
                    })
                }else{
                    this.$message({
                        message: "请选择要删除的数据",
                        type: "warning",
                    });
                }
            },

            showUserDialog(){
                this.$refs.eipUserDialog.showDialog();
            },
            showDialog(id) {
                this.groupId=id;
                this.search();
                this.dialogVisible = true;
            },
            userDialogOnConfirm(selection){
                if (!selection || selection.length == 0) {
                    this.$message.error("请至少选择一个用户");
                    return;
                }
                let ids = [];
                for (let user of selection) {
                    ids.push(user.id);
                }
                let param = {};
                param.groupId = this.groupId;
                param.ids = ids;
                req.post("${uc}/uc/ucGroupUser/v1/saveJson",param).then(res=>{
                    if (res.data.state) {
                        this.$message({
                            message: "分配用户成功",
                            type: "success",
                            showClose: true
                        });
                        this.search();
                    }else{
                        this.$message.error(res.data.message||"分配用户失败");
                    }
                });
            },
            handleClose(){
                this.dialogVisible=false;
            },
            handleSizeChange: function(size) {
                //每页下拉显示数据
                this.pagination.pageSize = size;
                this.search();
            },
            handleCurrentChange: function(currentPage) {
                //点击第几页
                this.pagination.page = currentPage;
                this.search();
            },
            swap(index, action){
                this.btnLoading = true;
                let ids = [];
                if(action == 'down'){
                    ids[0] = this.rows[index].groupUserId;
                    ids[1] = this.rows[index + 1].groupUserId;
                }else if(action == 'up'){
                    ids[0] = this.rows[index - 1].groupUserId;
                    ids[1] = this.rows[index].groupUserId;
                }
                this.$http.get(`${window.context.uc}/uc/ucGroupUser/v1/swapUser?ids=${ids.join(",")}`).then(resp=>{
                    if(resp.data && resp.data.state){
                        this.$message.success("切换成功")
                    }
                    this.search();
                    this.btnLoading = false;
                })
            }
        }

    }
</script>

<style scoped>

</style>
